/* global axios */

import ApiClient from './ApiClient';

function toQueryParams({
  page,
  perPage,
  sortDir,
  q,
  userId,
  action,
  auditableType,
  startDate,
  endDate,
} = {}) {
  return {
    page,
    per_page: perPage,
    sort_dir: sortDir,
    q,
    user_id: userId,
    action,
    auditable_type: auditableType,
    start_date: startDate,
    end_date: endDate,
  };
}

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true, apiVersion: 'v2' });
  }

  // Filtros: { page, perPage, sortDir, q, userId, action, auditableType, startDate, endDate }
  get(params = {}) {
    return axios.get(this.url, { params: toQueryParams(params) });
  }

  filtersMeta() {
    return axios.get(`${this.url}/filters_meta`);
  }

  exportCsv(params = {}) {
    return axios.get(`${this.url}/export`, {
      params: toQueryParams(params),
      responseType: 'blob',
    });
  }

  // Relatório consolidado: KPIs + top atores + distribuição por ação/entidade + série por dia.
  summary({ since, until } = {}) {
    return axios.get(`${this.url}/summary`, { params: { since, until } });
  }
}

export default new AuditLogs();
